export const findPathName = (pathname: string): string => {
  return pathname.replace('/', '');
};
export const findPathNameNoHash = (pathname: string): string => {
  return pathname.replace('#/', '');
};
